import React from "react";

// Long-form informative sections (crawlable text, no file loading required).
export const InfoSections = ({ sections, testId, eyebrow }) => (
  <section data-testid={testId} className="mx-auto max-w-4xl px-6 py-14 lg:px-8">
    {eyebrow && (
      <p className="mb-8 text-xs font-bold uppercase tracking-widest text-emerald-600">{eyebrow}</p>
    )}
    {sections.map((s, i) => (
      <article key={i} className="mb-12 last:mb-0">
        <h2 className="font-display text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">
          {s.title}
        </h2>
        {s.paras.map((p, j) => (
          <p key={j} className="mt-4 text-base leading-relaxed text-slate-600">
            {p}
          </p>
        ))}
      </article>
    ))}
  </section>
);
